import { TCoachType, TConversationCoachType } from "../state";

export const AI_COACH_GUIDE_URL =
  "https://www.enageed.jp/release-notes/260827#aifb";

export const AI_COACH_SELECT_DESCRIPTION =
  "生徒のストックのコメント欄に、選択したAIコーチからコメントが届きます。\n目的に合わせて、コーチを選択してください。\n※AIの回答は授業改善の参考情報としてご利用ください。内容が不正確な場合があります。このAIは、ENAGEEDワークスペース内のデータをモデルの学習には使用しません。";

export const AI_CONVERSATION_NOTE =
  "AIの回答は参考情報としてご利用ください。内容が不正確な場合があります。このAIは、モデルの学習には使用しません。";

export const CONVERSATION_AI_NAMES: Record<TConversationCoachType, string> = {
  gear: "GEAR",
  subject: "教科コーチ",
  writing: "文章力コーチ",
  thinking: "思考力コーチ",
};

export interface IAiCoach {
  type: TCoachType;
  name: string;
  description: string;
  exampleInput: string;
  exampleOutput: string;
}

export const AI_COACHES: IAiCoach[] = [
  {
    type: "subject",
    name: "教科コーチ",
    description:
      "生徒のストックに対して、教科内容の正誤や改善点をフィードバックします。",
    exampleInput:
      "力の合成と力の分解を学んだ。力の合成は、2つの力を足したもので、力の分解は大きい力の方から小さい力を引いたら求めることができる。分力を求めるときは三角比を用いて解くことができた。",
    exampleOutput:
      "力の合成について、複数の力を1つの力にまとめる考え方を理解できています。また、分力を求める際に三角比を用いる点も正しく捉えられています。\n\n一方で、力の分解は「大きい力から小さい力を引く」ことではありません。1つの力を、縦方向と横方向など、複数の方向に分けて表すことです。力は大きさだけでなく向きももつため、矢印や図を使って整理すると、合成と分解の違いをより正確に理解できます。",
  },
  {
    type: "writing",
    name: "文章力コーチ",
    description:
      "生徒のストックに対して、文章の読みやすさや伝わりやすさを添削します。",
    exampleInput:
      "努力って難しい。すぐに結果が見えないからこそ、みんな努力をするんだと思う。でも、結果が見えなかったとき、人は努力をやめてしまうのかな。そもそも「結果」とは、点数が上がることなのか、前よりできるようになることなのか。結果が何を指すのかは、人によって違う気がする。",
    exampleOutput:
      "「点数が上がることなのか」「前よりできるようになることなのか」と具体例を挙げているので、「結果とは何か」という問いが伝わりやすい文章です。\n\n一方で、冒頭の「結果が見えないから努力する」は、後半の「結果が見えないと努力をやめるのか」と少しつながりにくいため、「すぐに結果が見えなくても、人は努力を続ける」とすると自然です。最初の考えと、その後の展開がつながっているか確認すると、より説得力が増します。",
  },
  {
    type: "thinking",
    name: "思考力コーチ",
    description:
      "生徒のストックに問いを返し、新たな気づきや考えの深まりを促します。",
    exampleInput:
      "数学の宿題の締め切りを守れていない日が続き、それは計画を立てられていないからだと気づきました。部活や習い事の時間も考えて計画を立てることで、締め切りを守れるようになりました。これからも続けます！",
    exampleOutput:
      "締め切りを守れなかった原因を考え、計画を立てることで行動を変えられたのはよい気づきですね。今回の計画では、どの工夫が特に効果的だったのでしょうか？予定どおりに進まなかったときの対応も考えると、自分に合った学習方法がさらに見えてきそうです。",
  },
];
